import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "page-not-found" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", { class: "page-not-found__title title-very-big" }, "404", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "page-not-found__text text-raleway-18" }, "Oops! The page you are looking for could not be found.", -1)

import { store } from '@/store'
import { SeoDescription, SeoTitle } from '@/utils/seo/seo'
import { computed, onBeforeMount, ref, watch } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'NotFoundView',
  setup(__props) {

onBeforeMount(() => {
    const uiLang = ref(computed<string>(() => store.getters.getUserUiLang))
      SeoTitle('Tyre point: 404')
    switch(uiLang.value.toUpperCase()) {
        case 'SWEDISH':
            SeoDescription('Tire Points nätbutik säljer bildäck. Vi erbjuder ett brett utbud av rabatterade däck och fälgar i Europa.')
            break
        case 'FINLAND':
            SeoDescription('Tyre Point - verkkokauppa myy autonrenkaita. Tarjoamme laajan valikoiman edullisia renkaita ja vanteita Euroopassa.')
            break
        default:
            SeoDescription('The Tyre Point online store sells car tires. We offer a wide range of discount tires and rims in Europe.')
            break
    }
})

const uiLang = ref(computed<string>(() => store.getters.getUserUiLang))

watch(() => uiLang.value, () => {
    switch(uiLang.value.toUpperCase()) {
        case 'SWEDISH':
            SeoTitle('Tyre point: Order')
            SeoDescription('Tire Points nätbutik säljer bildäck. Vi erbjuder ett brett utbud av rabatterade däck och fälgar i Europa.')
            break
        case 'FINLAND':
            SeoTitle('Tyre point: Tilaukset')
            SeoDescription('Tyre Point - verkkokauppa myy autonrenkaita. Tarjoamme laajan valikoiman edullisia renkaita ja vanteita Euroopassa.')
            break
        default:
            SeoTitle('Tyre point: Orders')
            SeoDescription('The Tyre Point online store sells car tires. We offer a wide range of discount tires and rims in Europe.')
            break
    }
}, {
    deep: true,
})

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createVNode(_component_router_link, {
      to: "/",
      class: "page-not-found__button text-raleway-16"
    }, {
      default: _withCtx(() => [
        _createTextVNode("Go back to Home")
      ]),
      _: 1
    })
  ]))
}
}

})